/* iArena catalogue cards: hovering a colour dot shows that colour's photo on the card; leaving restores it. */
(function () {
  function card(el) { return el.closest('.thumbnail'); }
  function box(c) { return c && c.querySelector('.thumbnail__image .image__container'); }
  function show(dot) {
    var c = card(dot), b = box(c); if (!b || !dot.dataset.img) return;
    var ov = b.querySelector('.ar-card-preview');
    if (!ov) { ov = document.createElement('img'); ov.className = 'ar-card-preview'; ov.alt = ''; b.appendChild(ov); }
    if (ov.getAttribute('src') !== dot.dataset.img) ov.src = dot.dataset.img;
    ov.classList.add('is-on');
  }
  function hide(dot) {
    var c = card(dot), b = box(c); var ov = b && b.querySelector('.ar-card-preview');
    if (ov) ov.classList.remove('is-on');
  }
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.ar-dots a.ar-dot'); if (dot) show(dot);
  });
  document.addEventListener('mouseout', function (e) {
    var dot = e.target.closest && e.target.closest('.ar-dots a.ar-dot'); if (!dot) return;
    var to = e.relatedTarget; if (to && to.closest && to.closest('.ar-dots') === dot.closest('.ar-dots')) return;   // moving between dots
    hide(dot);
  });
  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest && e.target.closest('.ar-dots'); if (!row) return;
    var to = e.relatedTarget; if (to && to.closest && to.closest('.ar-dots') === row) return;
    var d = row.querySelector('a.ar-dot'); if (d) hide(d);
  });
})();
